import React, { useEffect } from 'react';
import $ from 'jquery';
import '../assets/css/loader.css';
const Loader = ({ show }) => {
  useEffect(() => {
    if (show) {
      $('body').scrollTop();
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', 'unset');
    }
  }, []);
  return (
    <React.Fragment>
      {show && (
        <div
          id="preloader"
          style={{ height: '100%', overflow: 'hidden;top:0px' }}
        >
          <div id="status">&nbsp;</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Loader;
